// 公共的侧边栏栏
import Layout from "@/pages/layout/layout";

// 不作为main组件子页面展示的页面单独写，如下
export const loginRouter = {
  path: "/login",
  name: "login",
  meta: {
    title: "Login - 登录",
    keepAlive: false,
  },
  component: () => import("@/pages/login/login"),
};
export const centerRouter = {
  path: "/center",
  name: "center",
  meta: {
    title: "center - 登录",
    keepAlive: false,
  },
  component: () => import("@/pages/login/center"),
};
// 错误页面
export const errorRouter = {
  path: "/error/:code",
  name: "error",
  meta: {
    title: "error",
  },
  component: () => import("@/pages/error/index"),
};

// 作为main组件子页面展示  但不在左侧菜单显示的路由卸载otherRoter里
export const otherRouter = {
  path: '',
  name: 'otherRouter',
  redirect: '/welcome',
  meta: {
    requireAuth: true,
    title: '首页',
  },
  component: Layout,
  children: [
    {
      path: 'home/welcome',
      name: 'welcome',
      meta: {
        title: '首页',
        keepAlive: false,
      },
      component: () => import('@/pages/home/welcome'),
    },
    {
      path: 'userManagement/userList',
      name: 'userList',
      meta: {
        title: '用户列表',
        keepAlive: true,
      },
      component: () => import('@/pages/userManagement/userList/userList'),
    },
    {
      path: 'userManagement/userDetail',
      name: 'userDetail',
      meta: {
        title: '用户详情',
        keepAlive: false,
      },
      component: () => import('@/pages/userManagement/userList/userDetail'),
    },
    {
      path: 'shopManagement/shopList',
      name: 'shopList',
      meta: {
        title: '商品列表',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/shopList/shopList'),
    },
    {
      path: 'shopManagement/addGoodsCategory',
      name: 'addGoodsCategory',
      meta: {
        title: '商品分类',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/shopList/addshopCategory'),
    },
    {
      path: 'shopManagement/shopAdd',
      name: 'shopAdd',
      meta: {
        title: '商品添加',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/shopList/shopAdd'),
    },
    {
      path: 'shopManagement/shopEdit',
      name: 'shopEdit',
      meta: {
        title: '商品编辑',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/shopList/shopEdit'),
    },
    {
      path: 'shopManagement/pendingShop',
      name: 'pendingShop',
      meta: {
        title: '待上架商品',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/pendingShop/pendingShop'),
    },
    {
      path: 'shopManagement/pendingShopEdit',
      name: 'pendingShopEdit',
      meta: {
        title: '商品编辑',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/pendingShop/pendingShopEdit'),
    },
    {
      path: 'shopManagement/pendingShopLook',
      name: 'pendingShopLook',
      meta: {
        title: '商品查看',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/pendingShop/pendingShopLook'),
    },
    {
      path: 'shopManagement/shopApply',
      name: 'shopApply',
      meta: {
        title: '商品审核',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/shopApply/shopApply'),
    },
    {
      path: 'shopManagement/shopComment',
      name: 'shopComment',
      meta: {
        title: '商品评论',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/shopComment/shopComment'),
    },
    {
      path: 'shopManagement/addComment',
      name: 'addComment',
      meta: {
        title: '新增评论',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/shopComment/addComment'),
    },
    {
      path: 'shopManagement/lookComment',
      name: 'lookComment',
      meta: {
        title: '查看评论',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/shopComment/lookComment'),
    },
    {
      path: 'shopManagement/tagManagement',
      name: 'tagManagement',
      meta: {
        title: '标签管理',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/tagManagement/tagManagement'),
    },
    {
      path: 'shopManagement/addTag',
      name: 'addTag',
      meta: {
        title: '新增标签',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/tagManagement/addTag'),
    },
    {
      path: 'shopManagement/applyShopEdit',
      name: 'applyShopEdit',
      meta: {
        title: '商品编辑',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/shopApply/applyShopEdit'),
    },
    {
      path: 'shopManagement/categoryManage',
      name: 'categoryManage',
      meta: {
        title: '类目管理',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/categoryManage/categoryManage'),
    },
    {
      path: 'shopManagement/transportationModel',
      name: 'transportationModel',
      meta: {
        title: '运费模板',
        keepAlive: true,
      },
      component: () => import('@/pages/shopManagement/transportationModel/transportationModel'),
    },
    {
      path: 'shopManagement/transportationModelEdit',
      name: 'transportationModelEdit',
      meta: {
        title: '查看模板',
        keepAlive: false,
      },
      component: () => import('@/pages/shopManagement/transportationModel/transportationModelEdit'),
    },
    {
      path: 'orderManagement/logisticsOrderList',
      name: 'logisticsOrderList',
      meta: {
        title: '物流订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderManagement/logisticsOrderList/logisticsOrderList'),
    },
    //投流平台菜单-开始
    {
      path: 'inflowShopManagement/shopList',
      name: 'inflowShopList',
      meta: {
        title: '商品列表',
        keepAlive: true,
      },
      component: () => import('@/pages/inflowShopManagement/shopList/shopList'),
    },
    {
      path: 'inflowShopManagement/addGoodsCategory',
      name: 'inflowSddGoodsCategory',
      meta: {
        title: '商品分类',
        keepAlive: false,
      },
      component: () => import('@/pages/inflowShopManagement/shopList/addshopCategory'),
    },
    {
      path: 'inflowShopManagement/shopAdd',
      name: 'inflowShopAdd',
      meta: {
        title: '商品添加',
        keepAlive: false,
      },
      component: () => import('@/pages/inflowShopManagement/shopList/shopAdd'),
    },
    {
      path: 'inflowShopManagement/addshopCategory',
      name: 'inflowAddShopCategory',
      meta: {
        title: '商品分类',
        keepAlive: false,
      },
      component: () => import('@/pages/inflowShopManagement/shopList/addshopCategory.vue'),
    },
    {
      path: 'inflowOrderManagement/logisticsOrderList',
      name: 'inflowLogisticsOrderList',
      meta: {
        title: '物流订单',
        keepAlive: true,
      },
      component: () => import('@/pages/inflowOrderManagement/logisticsOrderList/logisticsOrderList'),
    },
    {
      path: 'inflowOrderManagement/logisticsOrderDetail',
      name: 'inflowLogisticsOrderDetail',
      meta: {
        title: '详情订单',
        keepAlive: false,
      },
      component: () => import('@/pages/inflowOrderManagement/logisticsOrderList/logisticsOrderDetail'),
    },
    {
      path: 'inflowOrderManagement/afterOrderList',
      name: 'inflowAfterOrderList',
      meta: {
        title: '售后订单',
        keepAlive: true,
      },
      component: () => import('@/pages/inflowOrderManagement/afterOrderList/afterOrderList'),
    },
    {
      path: 'inflowOrderManagement/afterOrderDetail',
      name: 'inflowAfterOrderDetail',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () => import('@/pages/inflowOrderManagement/afterOrderList/afterOrderDetail'),
    },
    {
      path: 'inflowOrderManagement/settingAddress',
      name: 'settingAddress',
      meta: {
        title: '退货地址',
        keepAlive: false,
      },
      component: () => import('@/pages/inflowOrderManagement/afterOrderList/settingAddress'),
    },
    //投流平台菜单-结束
    {
      path: 'orderManagement/logisticsOrderDetail',
      name: 'logisticsOrderDetail',
      meta: {
        title: '详情订单',
        keepAlive: false,
      },
      component: () => import('@/pages/orderManagement/logisticsOrderList/logisticsOrderDetail'),
    },
    {
      path: 'orderManagement/afterOrderList',
      name: 'afterOrderList',
      meta: {
        title: '售后订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderManagement/afterOrderList/afterOrderList'),
    },
    {
      path: 'orderManagement/afterOrderDetail',
      name: 'afterOrderDetail',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () => import('@/pages/orderManagement/afterOrderList/afterOrderDetail'),
    },
    {
      path: 'financeManagement/commissionRecordsList',
      name: 'commissionRecordsList',
      meta: {
        title: '佣金记录表',
        keepAlive: true,
      },
      component: () => import('@/pages/financeManagement/commissionRecordsList/commissionRecordsList'),
    },
    {
      path: 'financeManagement/performanceList',
      name: 'performanceList',
      meta: {
        title: '员工业绩表',
        keepAlive: true,
      },
      component: () => import('@/pages/financeManagement/performanceList/performanceList'),
    },
    {
      path: 'financeManagement/performanceDetail',
      name: 'performanceDetail',
      meta: {
        title: '员工业绩表',
        keepAlive: false,
      },
      component: () => import('@/pages/financeManagement/performanceList/performanceDetail'),
    },
    {
      path: 'financeManagement/platformCommission',
      name: 'platformCommission',
      meta: {
        title: '平台佣金',
        keepAlive: true,
      },
      component: () => import('@/pages/financeManagement/platformCommission/platformCommission'),
    },
    {
      path: 'financeManagement/platformWithdrawal',
      name: 'platformWithdrawal',
      meta: {
        title: '平台提现',
        keepAlive: true,
      },
      component: () => import('@/pages/financeManagement/platformWithdrawal/platformWithdrawal'),
    },
    {
      path: 'financeManagement/platformDeposit',
      name: 'platformDeposit',
      meta: {
        title: '平台保证金',
        keepAlive: true,
      },
      component: () => import('@/pages/financeManagement/platformDeposit/platformDeposit'),
    },
    {
      path: 'financeManagement/frozenAmount',
      name: 'frozenAmount',
      meta: {
        title: '冻结金额',
        keepAlive: false,
      },
      component: () => import('@/pages/financeManagement/platformDeposit/frozenAmount'),
    },
    {
      path: 'financeManagement/platformSettlementFund',
      name: 'platformSettlementFund',
      meta: {
        title: '平台结算金',
        keepAlive: true,
      },
      component: () => import('@/pages/financeManagement/platformSettlementFund/platformSettlementFund'),
    },
    {
      path: 'financeManagement/platformSettlementFundDetail',
      name: 'platformSettlementFundDetail',
      meta: {
        title: '结算详情',
        keepAlive: false,
      },
      component: () => import('@/pages/financeManagement/platformSettlementFund/platformSettlementFundDetail'),
    },
    {
      path: 'mallManagement/mallRenovation',
      name: 'mallRenovation',
      meta: {
        title: '商城装修',
        keepAlive: true,
      },
      component: () => import('@/pages/mallManagement/mallRenovation/mallRenovation'),
    },
    {
      path: 'mallManagement/indexRenovation',
      name: 'indexRenovation',
      meta: {
        title: '首页装修',
        keepAlive: true,
      },
      component: () => import('@/pages/mallManagement/indexRenovation/indexRenovation'),
    },
    {
      path: 'mallManagement/inflowMallRenovation',
      name: 'mallRenovation',
      meta: {
        title: '商城装修',
        keepAlive: true,
      },
      component: () => import('@/pages/mallManagement/mallRenovation/inflowMallRenovation'),
    },
    {
      path: 'mallManagement/inflowIndexRenovation',
      name: 'indexRenovation',
      meta: {
        title: '首页装修',
        keepAlive: true,
      },
      component: () => import('@/pages/mallManagement/indexRenovation/inflowIndexRenovation'),
    },
    {
      path: 'mallManagement/pageSetting',
      name: 'pageSetting',
      meta: {
        title: '页面设置',
        keepAlive: true,
      },
      component: () => import('@/pages/mallManagement/pageSetting/pageSetting'),
    },
    {
      path: 'pageSetting/newPage',
      name: 'newPage',
      meta: {
        title: '新增页面',
      },
      component: () => import('@/pages/mallManagement/pageSetting/newPage'),
    },
    {
      path: 'pageSetting/inflowNewPage',
      name: 'inflowNewPage',
      meta: {
        title: '新增页面',
      },
      component: () => import('@/pages/mallManagement/pageSetting/inflowNewPage'),
    },
    {
      path: 'systemManagement/commissionSettings',
      name: 'commissionSettings',
      meta: {
        title: '佣金设置',
        keepAlive: true,
      },
      component: () => import('@/pages/systemManagement/commissionSettings/commissionSettings'),
    },
    {
      path: 'systemManagement/memberManagement',
      name: 'memberManagement',
      meta: {
        title: '员工管理',
        keepAlive: true,
      },
      component: () => import('@/pages/systemManagement/memberManagement/memberManagement'),
    },
    {
      path: 'systemManagement/administratorSettings',
      name: 'administratorSettings',
      meta: {
        title: '管理员设置',
        keepAlive: true,
      },
      component: () => import('@/pages/systemManagement/administratorSettings/administratorSettings'),
    },
    {
      path: 'systemManagement/rolesSettings',
      name: 'rolesSettings',
      meta: {
        title: '角色设置',
        keepAlive: true,
      },
      component: () => import('@/pages/systemManagement/rolesSettings/rolesSettings'),
    },
    {
      path: 'systemManagement/loginRecord',
      name: 'loginRecord',
      meta: {
        title: '登录记录',
        keepAlive: true,
      },
      component: () => import('@/pages/systemManagement/loginRecord/loginRecord'),
    },
    {
      path: 'systemManagement/customerSettings',
      name: 'customerSettings',
      meta: {
        title: '客服设置',
        keepAlive: true,
      },
      component: () => import('@/pages/systemManagement/customerSettings/customerSettings'),
    },
    {
      path: 'marketingManage/vipManage',
      name: 'vipManage',
      meta: {
        title: '会员管理',
        keepAlive: true,
      },
      component: () => import('@/pages/marketingManage/vipManage/vipManage'),
    },
    {
      path: 'marketingManage/vipLook',
      name: 'vipLook',
      meta: {
        title: '查看会员',
        keepAlive: false,
      },
      component: () => import('@/pages/marketingManage/vipManage/vipLook'),
    },
    {
      path: 'marketingManage/vipEquity',
      name: 'vipEquity',
      meta: {
        title: '会员权益',
        keepAlive: false,
      },
      component: () => import('@/pages/marketingManage/vipManage/vipEquity'),
    },
    {
      path: 'marketingManage/couponManage',
      name: 'couponManage',
      meta: {
        title: '优惠券管理',
        keepAlive: true,
      },
      component: () => import('@/pages/marketingManage/couponManage/couponManage'),
    },
    {
      path: 'marketingManage/couponDetail',
      name: 'couponDetail',
      meta: {
        title: '优惠券查看',
        keepAlive: false,
      },
      component: () => import('@/pages/marketingManage/couponManage/couponDetail'),
    },
    {
      path: 'couponManage/useDetail',
      name: 'useDetail',
      meta: {
        title: '使用详情',
        keepAlive: false,
      },
      component: () => import('@/pages/marketingManage/couponManage/useDetail'),
    },
    {
      path: 'couponManage/receiveDetail',
      name: 'receiveDetail',
      meta: {
        title: '领取详情',
        keepAlive: false,
      },
      component: () => import('@/pages/marketingManage/couponManage/receiveDetail'),
    }
  ]
}

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "",
    name: "toname",
    meta: {
      requireAuth: true,
    },
    component: Layout,
    children: [
      {
        path: "/main_view",
        name: "main_view",
        title: "首页",
        component: () => import("@/pages/main_view/main_view"),
      },
    ],
  },
];

export const routers = [loginRouter, centerRouter, errorRouter, otherRouter, ...appRouter];
